import { useEffect, useState } from 'react';
import { Alert, Collapse, message, Space, Col, Divider } from 'antd';
import { CopyOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from "react-router-dom";
import { BackToInvites, getInvitesPath } from '../../Components/EventDetails/SendInviteButton';
import { EventService } from '../../Services/EventService';
import Paragraph from 'antd/lib/typography/Paragraph';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import 'react-multi-email/dist/style.css';
import { AuthProvider } from '../../Providers/authProvider';
import { BookyTitleWithIcon } from '../../Components/Forms/TitleWithIcon';
import { SendInviteForm } from '../../Components/EventDetails/SendInviteForm';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { EventHeader } from '../../Components/EventDetails/EventHeader';
import LeftMenuEventDetails from './LeftMenuEventDetails';
import { EmailFormType } from '../../Types/EmailFormType';
import { EmailTemplateService } from '../../Services/EmailTemplateService';
import { WebApiModelsEmailTemplate } from '../../Repository/eventbookyapi';

const MyEventDetailsSendInviteExternal = () => {
  const [event, setEvent] = useState([] as any);
  const [groups, setGroups] = useState([] as any[]);
  const [subject, setSubject] = useState("" as string);
  const [imageSelect, setImageSelect] = useState("" as string);
  const GetText = TextService.GetText;
  const [emailTemplates, setEmailTemplates] = useState([] as WebApiModelsEmailTemplate[]);

  let params = useParams();
  const navigation = useNavigate();
  const { Panel } = Collapse;

  const loadEvent = (id: string) => {
    EventService.GetEventDetails(id).then(result => {
      setEvent(result);
      setSubject("Inbjudan till " + result.eventName);
    });
  };

  useEffect(() => {

    AuthProvider().ValidateUserLogin();
    if (params.id != null) {
      loadEvent(params.id);

      EmailTemplateService.GetTemplates().then(result => {
        setEmailTemplates(result);
      });
    }
  }, [params])


  return <LayoutLeftMenu hasTitleTop={true} header={<EventHeader event={event} />} title={GetText("SendInvite_SendInviteExternalTitle")} menu={<LeftMenuEventDetails selected={"sendInviteExternal"} membersOnly={event.membersOnly} />}>
    <Col xs={24} lg={16}>
      <BackToInvites event={event} />
      <Divider style={{ marginTop: "5px" }} />
      {event.membersOnly ?
        <Alert type="info" showIcon message={GetText("SendInvite_ExternalLockedTitle")} description={GetText("SendInvite_ExternalLockedDescription")} />
        :
        <>
          Vill du skicka till e-postadresser som inte ligger upplagda i medlemsregistret? Använd formuläret nedan där du kan skicka till externa e-postadresser.
          <br /><br />
          <SendInviteForm emailTemplates={emailTemplates} subject={subject} type={EmailFormType.EmailFormByExternal} event={event} onSent={() => navigation(getInvitesPath(event.eventUniqueId))}></SendInviteForm>
        </>
      }


    </Col >
  </LayoutLeftMenu >
};

export default MyEventDetailsSendInviteExternal;